import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { GameLeaderboard, GameContests } from '@golfgamebook/web-leaderboard'
import '@golfgamebook/web-leaderboard/dist/css/style.css'
import { API_ROOT } from 'config'
import { APIRoute } from 'routes/api'
import { selectLocale } from 'store/locale/slice'
import { useEffect, useState } from 'react'
import { getGame } from 'store/game/thunks'
import { selectGame } from 'store/game/slice'
import { selectCourse } from 'store/course/slice'
import { getCourse } from 'store/course/thunks'
import { userManager } from 'scenes/authentication/oicd'

interface ParamTypes extends ParamTypesBase {
  id: string
}

export default function GameWebLeaderboard(): JSX.Element {
  const dispatch = useDispatch()
  const { id: paramId } = useParams<ParamTypes>()
  const id = paramId || ''
  const locale = useSelector(selectLocale)
  const selectedLanguage = locale.language.code
  const { game } = useSelector(selectGame)
  const { course } = useSelector(selectCourse)
  const courseId = game?.courses[0].id
  const timezone = course.club?.timeZone?.zone

  const [headers, setHeaders] = useState<Headers>()

  useEffect(() => {
    if ((game === null || game.id !== id) && id !== '') {
      dispatch(getGame(Number(id)))
    }
  }, [dispatch, game])

  const getLeaderboardEndpoint = (): string => {
    return API_ROOT + APIRoute.GET_GAME_LEADERBOARD(Number(id))
  }

  const getContestsEndpoint = (): string => {
    return API_ROOT + APIRoute.GET_GAME_CONTESTS(Number(id))
  }

  useEffect(() => {
    userManager.getUser().then((user) => {
      setHeaders(() => {
        return new Headers({
          Authorization: user ? `Bearer ${user.access_token}` : '',
          'X-ID-Token': user?.id_token ?? '',
        })
      })
    })
  }, [])

  useEffect(() => {
    if (!game && Number(id)) {
      dispatch(getGame(Number(id)))
    }
  }, [id])

  useEffect(() => {
    if (courseId) {
      dispatch(getCourse(courseId))
    }
  }, [courseId])

  return (
    <Container>
      <GameLeaderboard
        endpoint={getLeaderboardEndpoint()}
        headers={headers}
        language={selectedLanguage}
        timezone={timezone}
        units={'metric'}
        gameOptions={{
          primary: game?.rounds.map((round) => round.primaryConfig) ?? [],
          side: game?.rounds.map((round) => round.secondaryConfig) ?? [],
        }}
      />
      <GameContests
        endpoint={getContestsEndpoint()}
        headers={headers}
        language={selectedLanguage}
        timezone={timezone}
        units={'metric'}
      />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 50px auto;
  width: 75%;
  min-height: 75vh;

  & > div:first-of-type {
    margin-bottom: 50px;
  }
`
